export const columns = () => {
  return [
    {
      headerName: "",
      field: "index",
      cellRenderer: (params: any) => {
        return params.rowIndex + 1;
      },
      minWidth: 30,
      maxWidth: 30,
      filter: false,
      sortable: false,
      suppressMovable: true,
      pinned: "left",
    },
    {
      headerName: "",
      field: "isChecked",
      minWidth: 70,
      width: 70,
      maxWidth: 70,
      pinned: "left",
      cellStyle: { textAlign: "center", justifyContent: "start" },
      filter: false,
      sortable: false,
      suppressMovable: true,
    },
    {
      headerName: "タイトル",
      field: "title",
      minWidth: 250,
      sortable: false,
      suppressMovable: true,
    },
    {
      headerName: "通知内容",
      field: "main_notice",
      minWidth: 360,
      sortable: false,
      suppressMovable: true,
    },
    {
      headerName: "開始日時",
      field: "maintenance_start_at",
      minWidth: 200,
      sortable: false,
      suppressMovable: true,
    },
    {
      headerName: "終了日時",
      field: "maintenance_end_at",
      minWidth: 200,
      sortable: false,
      suppressMovable: true,
    },
  ];
};

export const FILTER_PARAMS = {
  title: "q[title_cont]",
  main_notice: "q[main_notice_cont]",
  maintenance_start_at: "q[maintenance_start_at_cont]",
  maintenance_end_at: "q[maintenance_end_at_cont]",
};

export const WIDTH_OPERATOR = {
  small: 101,
  medium: 111,
  large: 126,
};
